<div class="camera-calendar-day">
  <div class="camera-calendar-day__header">
    <div class="camera-calendar-day__header-left">
      <button mat-icon-button (click)="onClickBack()" matTooltip="back to month">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h4 class="camera-calendar-day__title">{{ selectedDate() | date: 'yyyy-MM-dd' }}</h4>
    </div>
    <div class="camera-calendar-day__header-right">
      <button mat-icon-button (click)="onClickPrevious()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickNext()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  </div>

  @if (hasNonTimerRules()) {
    <div class="camera-calendar-day__timespan-wrapper">
      @for (timespan of scheduleTimespanPreview(); track timespan; let i = $index) {
        <rc-calendar-timespan
          [offset]="timespan.offset"
          [duration]="timespan.duration"
          [periodLength]="timespan.length"
          [showLegend]="false"
        ></rc-calendar-timespan>
      }
      @if (scheduleTimespanPreview()?.length) {
        <div class="camera-calendar-day__trigger-legend">
          <div class="camera-calendar-day__trigger-legend-active"></div>
          @for (label of nonTimerTriggerLabels(); track label) {
            <span class="camera-calendar-day__trigger-legend-label">Active {{ label }} </span>
          }
          <div class="camera-calendar-day__trigger-legend-offset"></div>
          <span class="camera-calendar-day__trigger-legend-label">Inactive</span>
        </div>
      }
      @if (!scheduleTimespanPreview()?.length) {
        <mat-error class="camera-calendar-day__error">No active schedule for this day.</mat-error>
      }
    </div>
  }

  @if (schedulePreview()?.length) {
    <div class="camera-calendar-day__wrapper">
      @for (s of schedulePreviewOfPage(); track s; let i = $index) {
        <ng-container
          *ngTemplateOutlet="item; context: { label: millisToString(s.millis), rule: s.rule }"
        ></ng-container>
      }
    </div>
    <button mat-button (click)="previousPage()" [disabled]="page <= 1">
      <mat-icon>keyboard_arrow_left</mat-icon>
      Previous
    </button>
    <button mat-button (click)="nextPage()" [disabled]="page > schedulePreview().length / 20">
      Next
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  }

  @if (!hasNonTimerRules() && !schedulePreview()?.length) {
    <mat-error class="camera-calendar-day__error">There is no fix!</mat-error>
  }
</div>

<ng-template #item let-label="label" let-rule="rule">
  <span class="camera-calendar-day__item active" matTooltip="{{ getTooltip(rule) }}">
    @if (rule?.cameraScheduleRuleType === 'PICTURE') {
      <div class="camera-calendar-day__item-mode">
        <mat-icon>camera_alt</mat-icon>
        {{ rule.size || '' }}
      </div>
    }
    @if (rule?.cameraScheduleRuleType === 'VIDEO') {
      <div class="camera-calendar-day__item-mode">
        <mat-icon>videocam</mat-icon>
        {{ rule.size || '' }}s
      </div>
    }
    <div class="camera-calendar-day__item-label">
      {{ label }}
    </div>
  </span>
</ng-template>

@if (schedulePreview()?.length) {
  <div class="camera-calendar-day__legend"></div>
}
